import { jsx } from "react/jsx-runtime";
import { Grid } from "@elliemae/ds-grid";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { DSSingleComboBox } from "@elliemae/ds-form-single-combobox";
import { DSMultiComboBox } from "@elliemae/ds-form-multi-combobox";
import { useMemo } from "react";
import {
  useSingleComboboxFieldUpdateLogic,
  useMultiComboboxFieldUpdateLogic
} from "./utils/fieldUpdateLogic";
const Combobox = ({
  renderedField,
  schemaForm,
  name,
  label,
  required,
  isMulti,
  pathValue,
  feedbackMessage,
  ui,
  options,
  disabled
}) => {
  const singleComboboxFieldUpdateLogic = useSingleComboboxFieldUpdateLogic();
  const multiComboboxFieldUpdateLogic = useMultiComboboxFieldUpdateLogic();
  const allComboboxOptions = useMemo(() => {
    const newOpts = options.map((option) => ({
      dsId: `${option.id}`,
      type: "option",
      label: `${option.text}`,
      value: `${option.value}`
    }));
    return newOpts || [];
  }, [options]);
  return /* @__PURE__ */ jsx(Grid, { span: ui.col_size, children: /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      name,
      label,
      inputID: name,
      required,
      feedbackMessage,
      children: isMulti ? /* @__PURE__ */ jsx(
        DSMultiComboBox,
        {
          ...renderedField,
          allOptions: options?.map((option) => ({
            dsId: option.id,
            type: "option",
            value: option.value,
            label: option.text,
            disabled: option.disabled
          })),
          selectedValues: Array.isArray(renderedField?.value) ? renderedField.value.map(
            (val) => allComboboxOptions.find(
              (option) => option.value === val.toString()
            )
          ).filter(Boolean) : [],
          onChange: multiComboboxFieldUpdateLogic(renderedField, schemaForm),
          id: pathValue,
          disabled
        }
      ) : /* @__PURE__ */ jsx(
        DSSingleComboBox,
        {
          ...renderedField,
          allOptions: options?.map((option) => ({
            dsId: option.id,
            type: "option",
            value: option.value,
            label: option.text,
            disabled: option.disabled
          })),
          onChange: singleComboboxFieldUpdateLogic(renderedField, schemaForm),
          selectedValue: allComboboxOptions.find(
            (option) => option.value === renderedField?.value?.toString()
          ) || null,
          id: pathValue,
          disabled
        }
      )
    }
  ) });
};
export {
  Combobox
};
